import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { MDBIcon } from "mdbreact";
import {
  Card,
  CardHeader,
  CardBody,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Label,
  CardFooter,
  Button,
  Badge,
  FormGroup,
  Input
} from "reactstrap";
import FormControl from '@material-ui/core/FormControl';
import axios from "utils/api";
import pageShowing from "utils/pageShowing";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    minWidth: '100%',
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const searchIcon = {
  position: "absolute",
  zIndex: 2,
  display: "block",
  width: "2.375rem",
  height: "2.375rem",
  lineHeight: "4rem",
  paddingLeft: "2.375rem",
  textAlign: "center",
  color: "#aaa"
};

const searchInput = {
  marginLeft: "20px",
  marginTop: "10px",
  paddingLeft: "3rem",
  width: "100%"
};

const submitButton = {
  marginLeft: "25px",
  marginTop: "10px",
  marginRight: "20px",
  height: "46px"
};

const UserManagement = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const classes = useStyles();
  const [users, setUsers] =  useState({ dataRows : [], dataCount : null, currentPage : 1 });
  const [status, setStatus] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState({ currentPage: 1, pageSize : 10, totalCount: 0 });
  const [formState, setFormState] = useState({ values: []});
  const pageNumbers = [];

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getUsers(status, searchText, page.currentPage, page.pageSize);

      var auditlog = { 
        moduleName: `Users`,
        accountId: authSession.merchantGroupCode,
        username: authSession.username,
        actionsTaken: `Viewed list of users`
      };
  
      axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
    }

    return () => {
      mounted = false;
    };
  },[]);

  const handlePageChange = (event) => {
    if (!(event.value < 1 || event.value > pageNumbers[pageNumbers.length - 1]) ) {
      getUsers(status, searchText, event.value, page.pageSize);
    }
  };

  const handleSearchChange = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    setPage(page => ({...page}));
  };

  const handleSearch = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    getUsers(status, searchText, page.currentPage, page.pageSize);
  };

  const getUsers = (status, searchValue, currentPage, pageSize) => {
    axios.post(`/user/get?merchantGroupId=${authSession.merchantGroupId}&searchValue=${searchValue}&status=${status}&currentPage=${currentPage}&pageSize=${pageSize}`).then(response => {
      setUsers({
        dataRows : response.data.users,
        dataCount : response.data.totalItems,
        currentPage : currentPage
      });

      setPage(page => ({
        ...page,
        currentPage: currentPage,
        pageSize: pageSize,
        totalCount : response.data.totalItems
      }));
    }).catch(() => { 
      console.log('There is a problem fetching users. Please try again later.');
    });
  };

  const handleStatusChange = (event) => {
    getUsers(event.target.value, searchText, page.currentPage, page.pageSize);

    setStatus(event.target.value);
  }

  const userAccess = (allowPortalAccess, allowDeviceAccess) => {
    if (allowPortalAccess && allowDeviceAccess)
      return 'Portal/Device';
    else if (allowPortalAccess) 
      return 'Portal';
    else if (allowDeviceAccess)
      return 'Device';
  }

  const userStatus = (status) => {
    if (status !== 1)
      return <Badge color="danger" style={{fontSize: "12px"}}>Inactive</Badge>;
    else
      return <Badge color="success" style={{fontSize: "12px"}}>Active</Badge>;
  }
  
  const renderTable = () => {
    return users.dataRows.map(user => {
      return (
        <tr>
          <td>{user.username}</td>
          <td>{user.emailAddress}</td>
          <td>{user.mobileNumber}</td>
          <td style={{textAlign: "center"}}>{userAccess(user.allowPortalAccess, user.allowDeviceAccess)}</td>
          <td style={{textAlign: "center"}}>{userStatus(user.status)}</td>
          <td style={{textAlign: "center"}}>
            <Button
              color="info"
              tag={Link}
              to={`/admin/user/${user.portalUserID}`}>
              <MDBIcon icon="edit"/> Edit
            </Button>
          </td>
        </tr>
      );
    });
  };

  const renderPageNumbers = () => { 
    if (page.totalCount !== null) {
      let totalPages = Math.ceil(page.totalCount / page.pageSize)
      if (totalPages > 10) {
        let maxPage = 10;
        let minPage = 1;
        if (totalPages >= maxPage) {
          if (users.currentPage >= maxPage) {
            maxPage = users.currentPage + 2;
            minPage = users.currentPage - 2;
          }

          if (minPage < 1)
            minPage = 1;

          if (maxPage >= totalPages)
            maxPage = totalPages;

          if ((maxPage - minPage) < 9)
          minPage = maxPage - 9;

          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
        else {
          if (minPage < 1)
            minPage = 1;
          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
      }
      else {
        for (let i = 1; i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      }
    }

    return pageNumbers.map(number => {
      let classes = users.currentPage === number ? 'active' : '';

      return (
        <PaginationItem className={classes} key={number}>
          <PaginationLink onClick={(e, val) => handlePageChange({ value: number})}> {number} </PaginationLink>
        </PaginationItem>
      );
    });
  };

  return (
    <>
     <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="page-header">
        <h1>User Management</h1>
        <h3>List of sub-users created in the system.</h3>
        <p>
          <MDBIcon icon="link" className="text-green" fixed /> 
          <a className="text-green" href="/admin/index"> Dashboard</a> / User Management 
        </p>
      </div>
      <Container>
        <Row>
          <div className="col">
            <Row>
              <Col md="12" xs="12">
                <Card className="card-stats mb-4 mb-xl-0 shadow">
                  <CardHeader className="border-0" style={{marginBottom: '-7px'}}>
                      <Container>
                        <Row>
                          <Col><h3 className="mb-0" style={{marginLeft: '-14px'}}>Users ({users.dataCount})</h3></Col>
                          <Col>
                            <Button size="md" outline color="info" style={{float: 'right', marginTop: "-10px"}} 
                              tag={Link} to={`user/add`}>
                              <MDBIcon icon="plus-circle" fixed /> Add
                            </Button>
                          </Col>
                        </Row>
                    </Container>
                  </CardHeader>
                  <hr className="mt--0 divider" />
                  <CardBody>
                    <Row>
                      <Col sm="8">
                        <FormGroup>  
                            <form className="d-flex">
                              <div className="form-group has-search w-100">
                                <span className="fa fa-search form-control-feedback" style={searchIcon}></span>
                                <Input className="form-control me-2"
                                  style={searchInput}
                                  type="search" 
                                  placeholder="Search users here..."
                                  aria-label="Search"
                                  name="searchValue"
                                  value={formState.searchValue}
                                  onChange={event => handleSearchChange(event)}
                                  onKeyPress={event => { if (event.key === "Enter") { handleSearch(event) }}}
                                  autoComplete="off">
                                </Input>
                              </div>
                            </form>
                          </FormGroup>
                      </Col>
                      <Col sm="2">
                        <FormControl className={classes.formControl}>
                          <Input type="select" name="status" id="status" onChange={handleStatusChange} style={{marginTop: '2px'}}>
                            <option value={0}></option>
                            <option value={1}>Active</option>
                            <option value={2}>Inactive</option>
                          </Input>
                        </FormControl>
                      </Col>
                      <Col sm="2">
                        <Button type="submit" style={submitButton} onClick={event => handleSearch(event)} color="info">SEARCH</Button>
                      </Col>
                    </Row>
                    <Table className="align-items-center table-flush" responsive>
                      <thead className="thead-light">
                        <tr>
                          <th rowSpan="2">Username</th>
                          <th rowSpan="2">Email Address</th>
                          <th rowSpan="2">Mobile Number</th>
                          <th style={{textAlign: "center"}}>Access</th>
                          <th rowSpan="2" style={{textAlign: "center"}}>Status</th>
                          <th rowSpan="2" className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        { users.dataCount !== 0
                          ?
                            renderTable()
                          :
                            <td colSpan="7" style={{textAlign: 'center'}}>
                              <Label size="sm" className="mr-sm-2"  >
                                <i>
                                  <MDBIcon icon="exclamation-triangle" /> No available users yet.
                                </i> 
                              </Label>
                            </td>
                        }
                      </tbody>
                    </Table>
                    <CardFooter className="py-4">
                      <Row className="mt-0" hidden={!(Math.ceil(page.totalCount / page.pageSize) > 1)}>
                        <Col xl="6" l="6">
                          {pageShowing(page.totalCount, page.pageSize, page.currentPage)}
                        </Col>
                        <Col  xl="6">
                          <Pagination  className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                            <PaginationItem>
                              <PaginationLink
                                onClick={() => handlePageChange({ value: (page.currentPage - 1)})}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-left" />
                                <span className="sr-only">Previous</span>
                              </PaginationLink>
                            </PaginationItem>
                            { renderPageNumbers()}
                            <PaginationItem>
                              <PaginationLink
                                onClick={() => handlePageChange({ value: (page.currentPage + 1)})}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-right" />
                                <span className="sr-only">Next</span>
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </Col>
                      </Row>
                    </CardFooter>
                  </CardBody>              
                </Card>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>
    </div>
    </>
  );
}

export default UserManagement;
